import { autoinject } from "aurelia-framework";
import { MultiLookupModel } from "./multi-checked-list-selector";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { LookupValue } from "../../../models/lookups/lookup.models";

@autoinject
export class MultiCheckedListDialog {

    // Function triggered when apply() method is triggered
    private _onApplyCallback: (multiLookups: MultiLookupModel[]) => void;

    // List of lookups
    public multiLookups: MultiLookupModel[];

    // Dialog title
    public title: string = "";

    // Is multi-checked-list-selector single select
    public isSingleSelect: boolean = false;

    constructor(private dialogClientService: DialogClientService) { }

    activate(model: { isSingleSelect:boolean, multiLookups: MultiLookupModel[], title: string, selectedIds: { [filterProperty: string]: number[] }, onApply: (multiLookups: MultiLookupModel[]) => void }) {
        this._onApplyCallback = model.onApply;
        this.title = model.title;
        this.isSingleSelect = model.isSingleSelect;

        if (model.multiLookups) {
            model.multiLookups.forEach((lookup: MultiLookupModel, index: number) => {

                if (lookup.filteredValues) {
                    lookup.filteredValues.forEach((filteredLookupValue: LookupValue) => {
                        filteredLookupValue.isSelected = false;
                        filteredLookupValue.isParentTicked = false;
                    });
                }

                if (!lookup.values) return;

                if (model.selectedIds && Object.keys(model.selectedIds).indexOf(lookup.propertyName) > -1) { // make sure only selected ids are set to true
                    const selectedValues = model.selectedIds[lookup.propertyName];
                    lookup.values.forEach((lookupValue: LookupValue) => {
                        const isSelected = (selectedValues?.indexOf(lookupValue.id) > -1);
                        let isParentTicked = (selectedValues?.indexOf(lookupValue.id) > -1? lookupValue.isParentTicked: false);
                        if (index > 0) {
                            const prevLookup = model.multiLookups[index - 1];
                            const hasSelectedParent = prevLookup.values.filter((prevLookupValue: LookupValue) => prevLookupValue.id == lookupValue.additionalData[lookup.joininPropertyName] && prevLookupValue.isSelected == true).length > 0;
                            isParentTicked = isParentTicked || hasSelectedParent;
                        }
                        lookupValue.isSelected = isParentTicked || isSelected;
                        lookupValue.isParentTicked = isParentTicked;

                        if ((isSelected || isParentTicked) && lookup.values) {
                            lookup.filteredValues.filter((filteredValue: LookupValue) => filteredValue.id == lookupValue.id)
                                .forEach((l: LookupValue) => {
                                    l.isSelected = lookupValue.isSelected;
                                    l.isParentTicked = lookupValue.isParentTicked;
                                });
                        }
                    });
                }
                //nothing selected, so set all is selected as false
                else {
                    lookup.values.forEach((lookupValue: LookupValue) => {
                        lookupValue.isSelected = false;
                        lookupValue.isParentTicked = false;
                    });
                }
            });
        }
        this.multiLookups = model.multiLookups;
    }

    /**
     * Apply filters method
     */
    apply() {
        this._onApplyCallback(this.multiLookups);
        this.closeDialog();
    }

    /**
     * Close multi-checked-list dialog
     */
    closeDialog() {
        this.dialogClientService.hide();
    }
}